<template>
  <div>

    <!--百度地图-->
    <baidu-map :style="{width: map.width, height: map.height}" class="map" :zoom="map.zoom"
               :center="{lng: map.center.lng, lat: map.center.lat}"
               :scroll-wheel-zoom="true" @zoomend="zoomChange" :mapStyle="mapStyle">

      <!--省份覆盖层-->
      <bm-boundary v-for="province of provinces" :name="province.name" :strokeWeight="1" strokeColor="red"
                   :fillOpacity="province.opacity" fillColor="red" :clicking="false">
      </bm-boundary>

      <!--比例尺控件-->
      <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
      <!--缩放控件-->
      <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" ></bm-navigation>
      <!--显示详细行程-->
      <div v-if="showDetail" v-for="markers of detailMarkers">
        <!--定位点-->
        <bm-marker v-for="marker of markers" :key="marker.code" :position="{lng: marker.lng, lat: marker.lat}" @click="infoWindowOpen(marker)">
          <bm-label :content="marker.descript" :labelStyle="{color: 'red', fontSize: '8px'}" :offset="{width: 0, height: 30}"/>
          <!--信息窗体-->
          <bm-info-window :position="{lng: marker.lng, lat: marker.lat}" :title="marker.descript" :show="marker.showInfo" @close="infoWindowClose(marker)">
            <p>{{marker.code}}</p>
          </bm-info-window>
        </bm-marker>
        <!--折线-->
        <bm-polyline :path="markers" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="4" :editing="false" :clicking="false">
        </bm-polyline>
      </div>
      <!--显示简略城市-->
      <div v-if="!showDetail">
        <!--定位点-->
        <bm-marker v-for="marker of briefMarkers" :key="marker.code" :position="{lng: marker.lng, lat: marker.lat}" @click="infoWindowOpen(marker)">
          <bm-label :content="marker.descript" :labelStyle="{color: 'red', fontSize: '8px'}" :offset="{width: 0, height: 30}"/>
          <!--信息窗体-->
          <bm-info-window :position="{lng: marker.lng, lat: marker.lat}" :title="marker.descript" :show="marker.showInfo" @close="infoWindowClose(marker)">
            <p>{{marker.desc}}</p>
          </bm-info-window>
        </bm-marker>
      </div>

    </baidu-map>

  </div>
</template>

<script>
import {tourApi} from '../../api/index';
import {HttpResp, BMapStyle} from '../../constant/index';
//百度地图
import BaiduMap from 'vue-baidu-map'
import BmScale from 'vue-baidu-map/components/controls/Scale';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation';
import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer';
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow';
import BmBoundary from 'vue-baidu-map/components/others/Boundary';

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  ak: 'uQQSc6GEFrtD9vEfpphUbbLlW9BLBUKW'
})

export default {
  name: 'tourMap',
  data() {
    return {
      mapStyle: BMapStyle.MAP_STYLE,
      showDetail: false,
      components: {
        BaiduMap,
        BmScale,
        BmNavigation,
        BmMarkerClusterer,
        BmInfoWindow,
        BmBoundary
      },
      briefMarkers: [],
      detailMarkers: [],
      provinces: [],
      map: {
        width: '100%',
        height: '700px',
        zoom: 5,
        center: {
          lng: 106.39,
          lat: 32.52,
        },
      },
    }
  },
  mounted: function () {
    this.loadData();
    this.listProvince();
  },
  computed: {

  },
  methods: {
    loadData: function () {
      tourApi.getBrief().then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.briefMarkers = data.data;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
      tourApi.getDetail().then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.detailMarkers = data.data;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    //查看信息框
    infoWindowOpen(data){
      data.showInfo = !data.showInfo;
    },
    //信息框关闭
    infoWindowClose(data){
      data.showInfo = false;
    },
    //地图缩放变化结束
    zoomChange(e){
      this.map.zoom = e.target.getZoom();
      this.showDetail = this.map.zoom > 7;
    },
    //查询省份列表
    listProvince() {
      tourApi.listProvince().then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.provinces = data.data;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/tour/TourMap.vue